export default "__VITE_ASSET__wV1TEILX__"